export default __webpack_public_path__ + "static/media/petar_s.87069b36.jpg";